import React from "react";
import Store from "../SessionStorage";
import { removeZero, sessionStorageAction } from "Utilities";

import { IoIosMail } from "react-icons/io";
import { IoPerson } from "react-icons/io5";
import { BsFileEarmarkTextFill } from "react-icons/bs";

const User = ({ isLoggedIn, numClientAltima, numContract, email }) => {
  const displayedNumAltima = isLoggedIn ? Store.get(sessionStorageAction.dashboard.client.numAltima) : numClientAltima;
  const displayedNumContrat = isLoggedIn ? Store.get(sessionStorageAction.dashboard.client.numContract) : numContract;

  return (
    <div className="admin-dashboard-infos-container">
      <div className="admin-dashboard-infos-line">
        <div className="admin-dashboard-infos-icon">
          <IoPerson size={20} />
        </div>
        <span className="admin-dashboard-infos-text">
          {displayedNumAltima}
        </span>
      </div>
      <div className="admin-dashboard-infos-line">
        <div className="admin-dashboard-infos-icon">
          <BsFileEarmarkTextFill size={18} />
        </div>
        <span className="admin-dashboard-infos-text">
          {removeZero(
            displayedNumContrat
          )}
        </span>
      </div>
      <div className="admin-dashboard-infos-line">
        <div className="admin-dashboard-infos-icon">
          <IoIosMail size={20} />
        </div>
        <span className="admin-dashboard-infos-text">
          {email}
        </span>
      </div>
    </div>
  )
};

export default User;